import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createFormatMoney } from './createFormatMoney';
import type { FormatMoney } from './FormatService';

/** Locale-aware money formatting via the active i18n language. */
export function useFormatMoney(): FormatMoney {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return useMemo(() => createFormatMoney(locale), [locale]);
}
